/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { StockCountDto } from '../models/stock-count-dto';
import { StockCountDtoDlmBaseResponse } from '../models/stock-count-dto-dlm-base-response';
import { StockCountDtoListDlmBaseResponse } from '../models/stock-count-dto-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class StockCountService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiStockCountStockCountsGet
   */
  static readonly ApiStockCountStockCountsGetPath = '/api/StockCount/stock-counts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountStockCountsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountStockCountsGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<StockCountDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountStockCountsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockCountDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountStockCountsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountStockCountsGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StockCountDtoListDlmBaseResponse> {

    return this.apiStockCountStockCountsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockCountDtoListDlmBaseResponse>) => r.body as StockCountDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountStockCountsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountStockCountsGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<StockCountDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountStockCountsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockCountDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountStockCountsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountStockCountsGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StockCountDtoListDlmBaseResponse> {

    return this.apiStockCountStockCountsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockCountDtoListDlmBaseResponse>) => r.body as StockCountDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiStockCountStockCountPut
   */
  static readonly ApiStockCountStockCountPutPath = '/api/StockCount/stock-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountStockCountPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPut$Plain$Response(params?: {
    body?: StockCountDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountStockCountPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountStockCountPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPut$Plain(params?: {
    body?: StockCountDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiStockCountStockCountPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountStockCountPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPut$Json$Response(params?: {
    body?: StockCountDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountStockCountPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountStockCountPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPut$Json(params?: {
    body?: StockCountDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiStockCountStockCountPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiStockCountStockCountPost
   */
  static readonly ApiStockCountStockCountPostPath = '/api/StockCount/stock-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountStockCountPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPost$Plain$Response(params?: {
    body?: StockCountDto
  }): Observable<StrictHttpResponse<StockCountDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountStockCountPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockCountDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountStockCountPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPost$Plain(params?: {
    body?: StockCountDto
  }): Observable<StockCountDtoDlmBaseResponse> {

    return this.apiStockCountStockCountPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StockCountDtoDlmBaseResponse>) => r.body as StockCountDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountStockCountPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPost$Json$Response(params?: {
    body?: StockCountDto
  }): Observable<StrictHttpResponse<StockCountDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountStockCountPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockCountDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountStockCountPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStockCountStockCountPost$Json(params?: {
    body?: StockCountDto
  }): Observable<StockCountDtoDlmBaseResponse> {

    return this.apiStockCountStockCountPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StockCountDtoDlmBaseResponse>) => r.body as StockCountDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiStockCountArchivePost
   */
  static readonly ApiStockCountArchivePostPath = '/api/StockCount/archive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountArchivePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountArchivePost$Plain$Response(params?: {
    stockCountId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountArchivePostPath, 'post');
    if (params) {
      rb.query('stockCountId', params.stockCountId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountArchivePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountArchivePost$Plain(params?: {
    stockCountId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiStockCountArchivePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockCountArchivePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountArchivePost$Json$Response(params?: {
    stockCountId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, StockCountService.ApiStockCountArchivePostPath, 'post');
    if (params) {
      rb.query('stockCountId', params.stockCountId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockCountArchivePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockCountArchivePost$Json(params?: {
    stockCountId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiStockCountArchivePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
